export default __webpack_public_path__ + "static/frame-2230-1--98267892aceeaa03cf0c96d05ffc220d.png";